import React from "react";

function Loader() {
  return (
    <div className="loaderContainer">
      <div className="loaderBg">
        <div className="loading"></div>
      </div>
    </div>
  );
}

export default Loader;
